import { render } from "./distribution-type-form.vue?vue&type=template&id=408d8d2f&scoped=true"
import script from "./distribution-type-form.vue?vue&type=script&lang=js"
export * from "./distribution-type-form.vue?vue&type=script&lang=js"

import "./distribution-type-form.vue?vue&type=style&index=0&id=408d8d2f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408d8d2f"]])

export default __exports__